<template>
  <div
    class="flex-1 border-0 border-t-4 border-solid transition-all"
    :class="[
      states.includes('idle') ? 'border-neutral-100' : 'border-light-green',
      states.includes('current') && 'rounded-r-lg'
    ]"
  ></div>
</template>

<script>
export default {
  name: 'StepListItem',
  props: {
    index: {
      type: Number,
      required: true,
      validator(prop) {
        return Number.isInteger(prop) && prop >= 0
      }
    },
    states: {
      type: Array,
      required: true,
      validator(prop) {
        return prop.every(e => ['current', 'done', 'idle'].indexOf(e) > -1)
      }
    }
  }
}
</script>
